import { createContext, use } from "react"

const ModalScrollParentContext = createContext<HTMLDivElement | null | undefined>(undefined)

interface ModalScrollParentProviderProps {
  value: HTMLDivElement | null
  children: React.ReactNode
}

export const ModalScrollParentProvider: React.FC<ModalScrollParentProviderProps> = ({ value, children }) => (
  <ModalScrollParentContext.Provider value={value}>{children}</ModalScrollParentContext.Provider>
)

export const useModalScrollParent = () => use(ModalScrollParentContext)
